export default "__VITE_ASSET__BQWNxm6l__"